import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import VueJwtDecode from "vue-jwt-decode";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem("token");
    let user = null;
    try {
      user = VueJwtDecode.decode(token);
    } catch (err) {
      console.log("router login", err);
      next("/login");
    }

    let token_expire = user.exp;
    if (token_expire <= Date.now() / 1000) {
      localStorage.removeItem("token");
      next({
        path: "login",
      });
    }

    if (to.meta.role && to.meta.role.includes(user.role)) {
      next();
    } else if (user.role === "driver") {
      next("/auth/home");
    } else if (user.role === "admin") {
      next("/");
    } else {
      next("/login");
    }
  } else {
    // Non-protected route, allow access
    next();
  }
});

export default router;
